export const managersEmployeesSelector = (state) =>
  state.employeesReducer.employees;
export const getSelectedEmployeeSelector = (state) =>
  state.employeesReducer.selectedEmployee;
export const getIsEmployeeCreated = (state) =>
  state.employeesReducer.employeeCreated;
export const getEmployeeDataExportLinkSelector = (state) =>
  state.employeesReducer.dataExportLink;
